export default {
  createFleetManagement: 'create_fleet_management',
  editFleetManagement: 'edit_fleet_management',
  viewFleetManagement: 'view_fleet_management'
}
